<template>
	<app-tooltip
		v-if="businessClosingTime.id"
		:text="$filters.returnReason(businessClosingTime)"
		:bgColor="online ? 'warning' : 'error'"
	>
		<div :class="containerClass" @click="changeBusinessStatus">
			<div class="w-5 h-5 bg-white rounded-full" />
		</div>
	</app-tooltip>

	<div v-else :class="containerClass" @click="changeBusinessStatus">
		<div class="w-5 h-5 bg-white rounded-full" />
	</div>
	<app-modal
		v-if="changing"
		title="Are you sure you want to switch your business to online?"
		@close="changing = false"
	>
		<div class="flex min-w-sm justify-end">
			<app-button
				icon="save"
				:class="`flex-1 btn ${online ? 'btn-primary' : 'btn-success'} mr-1`"
				:loading="loading"
				@click="goOnline"
			>
				Yes
			</app-button>
			<app-button
				icon="cancel"
				class="flex-1 btn btn-primary transparent"
				:loading="loading"
				@click="changing = false"
			>
				No
			</app-button>
		</div>
	</app-modal>
	<go-offline-modal
		v-if="showBusinessClosingReasons"
		:city-id="cityId"
		:business-id="businessId"
		@close="closeGoOfflineModal"
	/>
</template>

<script>
	import AppModal from '@/components/app/AppModal';
	import BusinessService from '@/services/sales/BusinessService';
	import GoOfflineModal from '@/components/sales/GoOfflineModal.vue';
	import AppTooltip from '@/components/app/AppTooltip.vue';

	export default {
		name: 'POSBusinessStatus',
		props: {
			online: {
				default: false,
			},
			businessId: {
				required: true,
			},
			cityId: {
				default: 1,
			},
			businessClosingTime: {
				type: Object,
				default: () => ({
					id: 0,
					notes: '',
					startDate: '',
					endDate: '',
					reason: '',
				}),
			},
		},
		components: {
			AppTooltip,
			GoOfflineModal,
			AppModal,
		},
		computed: {
			containerClass() {
				const common = ['flex rounded-full p-1 cursor-pointer w-12'];
				if (this.online) {
					common.push('bg-success');
				} else {
					common.push('bg-error justify-end');
				}
				if (this.loading) {
					common.push('opacity-50');
				}
				return common.join(' ');
			},
		},
		data: () => ({
			loading: false,
			changing: false,
			showBusinessClosingReasons: false,
		}),
		methods: {
			goOnline() {
				if (!this.loading) {
					this.loading = true;
					BusinessService.setBusinessOnline(this.businessId, this.cityId)
						.then(() => {
							this.$store.commit('SET_BUSINESS_ONLINE', this.businessId);
							this.$store.commit('SET_BUSINESS_CLOSING_TIME', {
								businessId: this.businessId,
								closingTime: { id: 0 },
							});
							this.$notificationService.success('Business is now online');
						})
						.catch((error) => {
							this.$notificationService.error(error);
						})
						.finally(() => {
							this.loading = false;
							this.changing = false;
						});
				}
			},
			changeBusinessStatus() {
				if (this.online) {
					this.showBusinessClosingReasons = true;
				} else {
					this.changing = true;
				}
			},
			closeGoOfflineModal() {
				this.showBusinessClosingReasons = false;
			},
		},
	};
</script>
